{
  "conversations": {
    "conversationsApp": "Application Conversations",
    "locationId": "ID d'emplacement",
    "idToken": "Jeton d'ID",
    "conversationRoutes": "Itinéraires de conversation",
    "conversationProviders": "Fournisseurs de conversation",
    "viewTheListOfConversation": "Voir la liste des conversations personnalisées ajoutées au compte ici.",
    "logo": "Logo",
    "name": "Nom",
    "alias": "Alias",
    "type": "Type"
  }
}
